import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCUTFYC7JQEQHjOl7Q3um3XAWEIrB1zmTc",
  authDomain: "tribal-sunbeam-464101-g8.firebaseapp.com",
  projectId: "tribal-sunbeam-464101-g8",
  storageBucket: "tribal-sunbeam-464101-g8.firebasestorage.app",
  messagingSenderId: "244975086849",
  appId: "1:244975086849:web:8f5a15e72af820d67cbf00"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
